import React from 'react';
import { Stack, Select, MenuItem, Typography, Pagination } from '@mui/material';

// Standard CMS pagination: "N / Entries per page" on the left, rounded page
// numbers + prev/next chevrons on the right. Used across all list views.
export const PAGE_SIZES = [10, 20, 50, 100];

export function Pager({
  page, pageCount, pageSize, total, onPage, onPageSize, sizeOptions = PAGE_SIZES,
}: {
  page: number; pageCount: number; pageSize: number; total?: number;
  onPage: (p: number) => void; onPageSize: (n: number) => void; sizeOptions?: number[];
}) {
  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between" flexWrap="wrap" gap={1.5} sx={{ mt: 2 }}>
      <Stack direction="row" alignItems="center" spacing={1}>
        <Select size="small" value={pageSize} onChange={(e) => onPageSize(Number(e.target.value))} sx={{ minWidth: 76 }}>
          {sizeOptions.map((n) => <MenuItem key={n} value={n}>{n}</MenuItem>)}
        </Select>
        <Typography variant="body2" color="text.secondary">
          Entries per page{typeof total === 'number' ? ` · ${total} total` : ''}
        </Typography>
      </Stack>
      <Pagination
        count={Math.max(1, pageCount)} page={page} shape="rounded" color="primary"
        siblingCount={1} boundaryCount={1} onChange={(_, p) => onPage(p)}
      />
    </Stack>
  );
}
